<template>
  <div class="table__bet__row__details">
    <slick
        class="table__bet__row__details__slider"
        :options="slickOptions"
        ref="slick_horse_details"
    >
      <div class="listingItemLI">
        <ul v-if="horse">

          <li v-if="isMobile">
            <div class="ulLiscnd">
              Jockey
              <br>
              <span class="bold"> {{ runner.rider.name }}</span>
            </div>
            <div class="ulLiscnd">
              Musique
              <br>
              <span class="bold">  {{ musiqueParser(runner.shortperformance) }}</span>
            </div>
            <div class="ulLiscnd">
              <span v-if="runner.startbox">{{ t('racecard.betslip.th.startbox') }}</span>
              <br>
              <span class="bold">{{ runner.startbox }}</span>
            </div>

          </li>
          <li>
            <div class="ulLiscnd">
              <span class="numberBlue">{{ horse.runs }}</span>
              courses
            </div>
            <div class="ulLiscnd">
              <span class="numberBlue">{{ horse.wins }}</span>
              victoires
            </div>
            <div class="ulLiscnd">
              <!--<span class="numberBlue">3</span>dans les 3 premiers-->
            </div>

          </li>
          <li>
            <div class="ulLiscnd">
              <span class="bold">GAINS TOTAUX</span>
            </div>
            <div class="ulLiscnd">
              <span class="numberBlue" v-html="formatToMoney(horse.winamount * 100, 2, true)"></span>
            </div>
            <div class="ulLiscnd"></div>

          </li>
          <li>
            <div class="ulLiscnd">Meilleur temps</div>
            <div class="ulLiscnd">{{ horse.recordtime }}</div>
            <div class="ulLiscnd"></div>

          </li>
          <li v-if="horse">
            <div class="ulLiscnd">Pere <br>
              <span class="bold"> {{ horse.father }}</span>
            </div>
            <div class="ulLiscnd">Mere
              <br>
              <span class="bold">  {{ horse.mother }}</span>
            </div>
            <div class="ulLiscnd"></div>

          </li>

        </ul>

      </div>
      <div class="listingItemLI listingItemLI--table">
        <ul v-if="horse">
          <li class="title">{{ t('runner.details.annual.title') }}</li>
          <li v-if="!isMobile">
            <div class="ulLi">{{ t('runner.details.annual.year') }}</div>
            <div class="ulLi">{{ t('runner.details.annual.type') }}</div>
            <div class="ulLi">{{ t('runner.details.annual.starts') }}</div>
            <div class="ulLi">{{ t('runner.details.annual.wins') }}</div>
            <div class="ulLi">{{ t('runner.details.annual.places') }}</div>
            <div class="ulLi">{{ t('runner.details.annual.money') }}</div>
            <div class="ulLi">{{ t('runner.details.annual.time') }}</div>
          </li>
          <li v-for="(stat, index) in horse.stats" :key="'stat-'+stat.horse_id+'_'+index">
            <div class="ulLi" :data-title="t('runner.details.annual.year')">{{ stat.year }}</div>
            <div class="ulLi" :data-title="t('runner.details.annual.type')">{{ stat.racetype }}</div>
            <div class="ulLi" :data-title="t('runner.details.annual.starts')">{{ stat.starts }}</div>
            <div class="ulLi" :data-title="t('runner.details.annual.wins')">{{ stat.wins }}</div>
            <div class="ulLi" :data-title="t('runner.details.annual.places')">{{ stat.places }}</div>
            <div class="ulLi" :data-title="t('runner.details.annual.money')">
              {{ formatToMoney(stat.money * 100) }}
            </div>
            <div class="ulLi" :data-title="t('runner.details.annual.time')"> {{ stat.recordtime }}</div>
          </li>
        </ul>

      </div>
      <div class="listingItemLI listingItemLI--table">
        <ul v-if="horse">
          <li class="title">{{ t('runner.details.performance.title') }}</li>
          <li v-if="!isMobile">
            <div class="ulLi">{{ t('runner.details.performance.date') }}</div>
            <div class="ulLi">{{ t('runner.details.performance.racetrack') }}</div>
            <div class="ulLi">{{ t('runner.details.performance.distance') }}</div>
            <div class="ulLi">{{ t('runner.details.performance.place') }}</div>
            <div class="ulLi">{{ t('runner.details.performance.driver') }}</div>
            <div class="ulLi">{{ t('runner.details.performance.gain') }}</div>
            <div class="ulLi">{{ t('runner.details.performance.cote') }}</div>
          </li>
          <li v-for="(form, index) in horse.forms" :key="'form-'+index+'_'+horse.id">
            <div class="ulLi" :data-title="t('runner.details.performance.date')">
              {{ formatToDate(form.date, 'DD.MM.YYYY') }}
            </div>
            <div class="ulLi" :data-title="t('runner.details.performance.racetrack')">{{ form.track }}</div>
            <div class="ulLi" :data-title="t('runner.details.performance.distance')">{{ form.distance }} m</div>
            <div class="ulLi" :data-title="t('runner.details.performance.place')">{{ form.place }}</div>
            <div class="ulLi" :data-title="t('runner.details.performance.driver')">{{ form.jockey }}</div>
            <div class="ulLi" :data-title="t('runner.details.performance.gain')">
              {{ formatToMoney(parseFloat(form.raceprizemoney) * 100) }}
            </div>
            <div
                class="ulLi"
                v-if="(isMobile && form.odd) || !isMobile"
                :data-title="t('runner.details.performance.cote')"
            > {{ form.odd }}
            </div>
          </li>
        </ul>

      </div>
    </slick>
  </div>
</template>
<script>
//SCRATCH

import Slick from 'vue-slick';
import {instance, raceApi} from '@/api';

export default {
  name: 'RunnerDetails',
  components: {Slick},
  props: ['runner'],
  data() {
    return {
      horse: null,
      slickOptions: {
        mobileFirst: true,
        slidesToShow: 1,
        swipeToSlide: true,
        dots: true,
      }
    }
  },

  computed: {},
  mounted() {
    this.getHorse(this.runner.horse.id);


  },
  methods: {

    getHorse(id) {
      instance.get(raceApi.horse + id).then((responce) => {
        if (responce.data.status === 'SUCCESS' && responce.data.content.horse) {
          this.horse = responce.data.content.horse;
        }
      })
    },

  }
}
</script>
<style lang="scss">


</style>
